import {newRequest} from '@/utils/request'
import request1 from '@/utils/request1'

// 店铺列表
export const getShopList = <T>() => newRequest.post<Ajax.Response<T>>('/authority/shop/querylist')

// 仓库列表
export const getWarehouseList = <T>() => newRequest.post<Ajax.Response<T>>('/authority/warehouse/querylist')

// 获取上传图片所需参数
export const getUploadPicSign = <T>(params: any) => request1.get<Ajax1.Response<T>>('/supplier/upload_pic_sign', params)

// 获取供应商下拉框数据
export const getSupplierSelectList = <T>() => newRequest.get<Ajax.Response<T>>('/goods/hoomiGoods/selectSupplierCombobox')